// Distributor articles in the Unicity Help Center (unicity.com, hosted in
// Builder.io) live at /{market}/{language}/help-center/distributor-view/...
// They are only published in English, Spanish and French, and many
// market/language pairs either 404 or redirect to a broken page, so each
// supported language maps to one known-good locale and the rest fall back
// to English.
const HELP_CENTER_BASE_URL = "https://www.unicity.com";

const HELP_CENTER_LOCALES = {
  en: "usa/en",
  es: "usa/es",
  fr: "fra/fr"
};

export const HELP_CENTER_PAGES = {
  home: "",
  dashboard: "distributor/unicity-office/unicity-office/understanding-the-dashboard",
  actionHub: "distributor/unicity-office/unicity-office/using-the-action-hub",
  centurion: "distributor/building-the-business/compensation-and-rewards/what-is-centurion",
  referralLinks: "distributor/building-the-business/growing-my-business/what-are-referral-links",
  displayName: "distributor/unicity-office/unicity-office/changing-your-display-name"
};

export const getHelpCenterUrl = (page, language = "en") => {
  const locale = HELP_CENTER_LOCALES[language.split("-")[0]] ?? HELP_CENTER_LOCALES.en;
  const path = HELP_CENTER_PAGES[page];
  return `${HELP_CENTER_BASE_URL}/${locale}/help-center/distributor-view${path ? `/${path}` : ""}`;
};
